










import Vue from "vue";
import { Component } from "vue-property-decorator";
import StaticPageResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/StaticPageModels/StaticPageResponse";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import { Route, NavigationGuard, RawLocation } from "vue-router";
@Component({
  // beforeRouteUpdate:function(to, from, next){
  //   console.log('beforeRouteUpdate deorator');
  //   next();
  // }
})
export default class PageStaticComponent extends Vue {
  content: string;

  model: WsResponseModel<StaticPageResponse> = null;

  created() {
    this.getByCode();
  }

  getByCode() {
    this.$api.StaticPagesService.GetByCodeEvent.once(
      this.onGetByCode.bind(this)
    );
    this.$api.StaticPagesService.GetByCode(this.$route.params.code);
  }
  onGetByCode(response: WsResponseModel<StaticPageResponse>) {
    this.model = response;
        if(response.Value)
          this.$meta.setTitle(response.Value.Name);
  }
  beforeRouteUpdate(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    next();
    this.getByCode();
  }
}
